import React, { useState, useEffect } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import { toast } from 'react-toastify';
import styled from 'styled-components';
import { WellnessHubHeading } from '../../../containers/Education/styles';
import { BackArrowFeed, VerticalDotsIcon, AdminDeleteIcon, LaunchEventIcon, WarningDelete } from '../../../utils/icons';
import { fetchApi } from '../../../utils/methods';
import { GetInitiativeCategoryLibrary, ArchiveInitiative } from '../../../redux/constants/apiConstants';
import { ImageUrl } from '../../../utils/constants';
import SkeletonLoder from '../../common/skeletonLoder';
import { DownAngleV2 } from '../../SocialFeedsV2/styles';
import { NoData } from '../../EngagementSectionV2/styles';
import CommonModal from '../../common/CommonModal/CommonModal';
import { HoverBackground } from './styles';
import { CommonButtonPopup } from '../../ReportsV2/styles';
import ViewInitiativeInfoPopup from './ViewInitiativeInfoPopup';

const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 24px;
`;

const Card = styled.div`
  background: #FEFEFE;
  border: 0.75px solid #DCDCDC;
  border-radius: 12px;
  overflow: hidden;
`;

const ImageArea = styled.div`
  position: relative;
  width: 100%;
  height: 252px;
  background: ${(props) => props.bgColor || '#f0f6f8'};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  > img.full-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  > img.icon-img {
    width: 60px;
    height: 60px;
  }
`;

const DetailsRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px;
  border-top: 0.75px solid #DCDCDC;
`;

const CardTitle = styled.div`
  font-family: Lato;
  font-size: 16px;
  font-weight: 700;
  color: #184A61;
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-right: 12px;
`;

function InitiativeCategoryLibraryPage({ companyInfo , allRoles}) {
  const history = useHistory();
  const location = useLocation();
  const { categoryId } = useParams();

  const categoryName = location.state?.category || 'Initiatives';

  const [initiatives, setInitiatives] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hoveredId, setHoveredId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedInitiative, setSelectedInitiative] = useState(null);
  const [initiativeDetails, setInitiativeDetails] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [viewInfoModal, setViewInfoModal] = useState(false);



  const openInfoModal = (initiative) => {
    setInitiativeDetails(initiative);
    setViewInfoModal(true);
  };

  const onConfirm = () => {
    setViewInfoModal(false);
    history.push({pathname:`/company/initiative-details/${initiativeDetails?.company_initiative_id}` , state:{initiativeDetails:initiativeDetails, fromLibrary: true}});
  }




  window.console.log("initiatives",initiatives)
  const isWellnessAdmin = allRoles?.some((role) => role.rid === 12);


  useEffect(() => {
    if (!categoryId) return;
    fetchInitiatives();
  }, [categoryId]);

  const fetchInitiatives = async () => {
    setLoading(true);
    try {
      const res = await fetchApi(
        `${GetInitiativeCategoryLibrary}?company_id=${companyInfo?.id}&category_id=${categoryId}`,
        'GET'
      );
      if (res.status === 'success') {
        setInitiatives(Array.isArray(res?.data) ? res.data : []);
      } else {
        toast.error(res.error || 'Failed to fetch initiatives');
      }
    } catch (error) {
      window.console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (initiative) => {
    history.push({
      pathname: '/company/health-initiatve/create',
      state: { initiativeData: initiative },
    });
  };

  const openDeleteModal = (initiative) => {
    setSelectedInitiative(initiative);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setSelectedInitiative(null);
  };

  const confirmDelete = async () => {
    setDeleteLoading(true);
    const payload = { initiative_id: selectedInitiative?.id };
    try {
      const res = await fetchApi(`${ArchiveInitiative}`, 'DELETE', payload);
      if (res.status === 'success') {
        toast.success('Initiative deleted successfully');
        setInitiatives((prev) => prev.filter((i) => i.id !== selectedInitiative?.id));
        closeDeleteModal();
      } else {
        toast.error(res.error || 'Failed to delete initiative');
      }
    } catch (error) {
      window.console.error(error);
    } finally {
      setDeleteLoading(false);
    }
  };

  const handleLaunch = (initiative) => {
    history.push({
      pathname: '/company/company-initiative',
      state: { id: initiative?.id, initiative_name: initiative?.initiative_name, initiativeDetails: initiative, fromCategory: true,categoryId,categoryName   },
    });
  };

  return (
    <div style={{ maxWidth: '1246px', padding: '24px 0px 40px 0px', margin: 'auto', width: '100%' }}>
      <WellnessHubHeading>
        <div className="right-row">
          <div className="icon"  onClick={() => history.push({ pathname: '/company/health', state: 'library' })}>
            {BackArrowFeed('#DA6C74')}
          </div>
          <div className="health-hub-title">{categoryName}</div>
        </div>
      </WellnessHubHeading>

      {loading ? (
        <SkeletonLoder width="1246px" height="300px" />
      ) : !initiatives.length ? (
        <NoData>No initiatives found for this category.</NoData>
      ) : (
        <CardGrid>
          {initiatives.map((initiative) => {
            const imgSrc = initiative?.thumbnail || initiative?.initiative_image;
            return (
              <Card key={initiative.id}>
                <ImageArea
                  bgColor={!imgSrc ? (initiative?.color || '#f0f6f8') : undefined}
                  onMouseEnter={() => setHoveredId(initiative.id)}
                  onMouseLeave={() => setHoveredId(null)}
                >
                  {imgSrc ? (
                    <img className="full-img" src={`${ImageUrl}/${imgSrc}`} alt={initiative?.initiative_name} />
                  ) : (
                    <img className="icon-img" src={`${ImageUrl}/${initiative?.initiative_white_icon}`} alt={initiative?.initiative_name} />
                  )}
                  {hoveredId === initiative.id && (
                    <HoverBackground>
                      <CommonButtonPopup
                        onClick={() =>
                          initiative?.re_launch_status
                            ? handleLaunch(initiative)
                            : openInfoModal(initiative)
                            // : history.push(`/company/initiative-details/${initiative?.company_initiative_id}`)
                        }
                        height={'40px'}
                      >
                        {initiative?.re_launch_status ? <LaunchEventIcon /> : null} {initiative?.re_launch_status  ? "Launch Initiative" : " View Initiative"}
                      </CommonButtonPopup>
                    </HoverBackground>
                  )}
                </ImageArea>

                <DetailsRow>
                  <CardTitle title={initiative?.initiative_name}>
                    {initiative?.initiative_name}
                  </CardTitle>
                  {isWellnessAdmin ? null :<DownAngleV2 feed padding="0 8px" marginL="-120px">
                    <DropdownButton
                      id={`initiative-${initiative.id}`}
                      title={<VerticalDotsIcon height="18px" />}
                    >
                      <Dropdown.Item onClick={() => handleEdit(initiative)}>Edit</Dropdown.Item>
                      <Dropdown.Item onClick={() => openDeleteModal(initiative)}>Delete</Dropdown.Item>
                    </DropdownButton>
                  </DownAngleV2>}
                </DetailsRow>
              </Card>
            );
          })}
        </CardGrid>
      )}

      {showDeleteModal && (
        <CommonModal
          show={showDeleteModal}
          icon={WarningDelete('#184A61')}
          buttonIcon={AdminDeleteIcon('#ffffff')}
          title="Delete Initiative"
          description="Are you sure you want to delete this initiative?"
          subDescription="This action cannot be undone, and all associated data will be permanently removed from the system."
          cancelText="Keep Initiative"
          confirmButtonText="Delete Initiative"
          confirmButtonWidth="182px"
          onCancel={closeDeleteModal}
          onConfirm={confirmDelete}
          confirmDisabled={deleteLoading}
          descriptionColor="#C13D4D"
          isFontSize="16px"
        />
      )}



      { viewInfoModal && <ViewInitiativeInfoPopup onConfirm={onConfirm} showModal={viewInfoModal} onClose={()=>setViewInfoModal(false)}  initiativeDetails={initiativeDetails} />}


    </div>
  );
}

InitiativeCategoryLibraryPage.propTypes = {
  companyInfo: PropTypes.object,
  allRoles: PropTypes.array,
  
};

const mapStateToProps = (state) => ({
  companyInfo: state.companyDashboard.companyInfo,
  allRoles: state.profileData.allRoles,

});

export default connect(mapStateToProps)(InitiativeCategoryLibraryPage);
